import React from "react"
import { reportFormData } from "Pages/ReportsAlerts/Reports/@signals"
import { Grid } from "@mui/material"
import { AppAntSwitch } from "@components"
import { useSignal } from "@preact/signals-react"
import {
	ReportDateMaxExecution,
	ReportDateMinExecution
} from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Fields/FrequencyNotification/DateRangeExecutionFields"


export default function () {

	const useDateRange = useSignal(!!reportFormData.peek().executionDateMin && !!reportFormData.peek().executionDateMax)

	return <Grid container spacing={2}>
		<Grid item xs={4}>
			<ReportDateMinExecution useDateRange={useDateRange.value}/>
		</Grid>
		<Grid item xs={4}>
			<ReportDateMaxExecution useDateRange={useDateRange.value}/>
		</Grid>
		<Grid item xs={4}>
			<AppAntSwitch
				trueText="Use execution date range"
				checked={useDateRange.value}
				onChange={e => useDateRange.value = e.target.checked}
			/>
		</Grid>
	</Grid>
}